import { Badge } from '@/components/ui/badge';
import { Card, CardContent, CardTitle } from '@/components/ui/card';
import { HintTooltip } from '@/components/HintTooltip';
import type { FC, ReactNode } from 'react';

/** The gates a match passes, broadest first; a recall and a catalog model each explain their own. */
export type MatchTier = 1 | 2 | 3;

/** The tier number as a badge whose hover says what the gate decides. */
export const TierBadge: FC<{ tier: MatchTier; hint: ReactNode }> = ({ tier, hint }) => (
    <HintTooltip hint={hint} className="ml-auto">
        <Badge variant="outline">Tier {tier}</Badge>
    </HintTooltip>
);

/** One gate's card: its title, an optional state badge, the tier badge with its hint, then the gate's content. */
export const TierCard: FC<{
    title: string;
    tier: MatchTier;
    hint: ReactNode;
    badge?: ReactNode;
    children: ReactNode;
}> = ({ title, tier, hint, badge, children }) => (
    <Card className="gap-0 py-4">
        <CardContent className="flex flex-col gap-2">
            <div className="flex items-center gap-2">
                <CardTitle className="text-base">{title}</CardTitle>
                {badge}
                <TierBadge tier={tier} hint={hint} />
            </div>
            {children}
        </CardContent>
    </Card>
);
